import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { SecurityService } from '../security.service';

export const portalAccessGuard: CanActivateFn = (
  _route,
  _state,
  securityService: SecurityService = inject(SecurityService),
  router: Router = inject(Router)
): Observable<true | UrlTree> => {
  return securityService.$authorizationStartupInProgress.pipe(
    filter(startup => !startup),
    take(1),
    map(() => securityService.hasPortalAccess() ? true : router.parseUrl('/security'))
  );
};
